const BattleCalc = require('../BattleCalc');
const BlockEvent = require('../events/BlockEvent');
const DodgeEvent = require('../events/DodgeEvent');
const DamageEvent = require('../events/DamageEvent');
const PoisonedCondition = require('../conditions/PoisonedCondition');
const BleedingCondition = require('../conditions/BleedingCondition');
const ScaredCondition = require('../conditions/ScaredCondition');
const StunnedCondition = require('../conditions/StunnedCondition');
const HealEvent = require('../events/HealEvent');

const StandardStrike = function (ability, battleState) {
  this.execute = function (
    actor,
    victim,
    baseDamage,
    blockable,
    is_dummy = false
  ) {
    const _cause = this;
    const result = {};

    const rollForBlock = () => {
      var off_hand = victim.equipment.off_hand;
      var chanceToBlock =
        off_hand?.type === 'shield' ? 0.2 * off_hand.quality : 0;

      if (BattleCalc.getCondition(victim, 'blocking')) {
        result.blocked = true;
      } else if (ability.ranged) {
        var md = BattleCalc.getEquippedAbility(victim, 'missile_defense');
        if (md && md.potency > Math.random()) {
          chanceToBlock += md.potency;
        }
      }

      if (Math.random() <= chanceToBlock) {
        result.blocked = true;
      }

      if (result.blocked) {
        var blockEvent = new BlockEvent(battleState, victim);
        blockEvent.execute();
      }
      return result.blocked;
    };
    const rollForDodge = () => {
      if (
        victim.attributes.dodgeChance + getDodgeFromBanners() >
        Math.random() * 100
      ) {
        var dodgeEvent = new DodgeEvent(battleState, victim);
        dodgeEvent.execute();
        result.dodged = true;
        return true;
      }

      return false;
    };
    const getDodgeFromBanners = () => {
      // var teamBanners = battleState.banners[victim.team];

      // for( var i = 0; i < teamBanners.length; ++i ) {
      // 	if( teamBanners[i] && teamBanners[i].handle === 'avoidance' ) {
      // 		return teamBanners[i].potency;
      // 	}
      // }

      return 0;
    };
    const rollForStrike = () => {
      if (
        !victim ||
        victim.dead ||
        !victim.inPlay ||
        !actor ||
        actor.dead ||
        !actor.inPlay
      ) {
        return false;
      }

      if (rollForBlock() || rollForDodge()) {
        return false;
      }

      return true;
    };

    if (blockable && rollForStrike() === false) {
      result.success = false;
      return result;
    }

    result.success = true;
    const damageEvent = new DamageEvent(
      battleState,
      actor,
      baseDamage,
      ability
    );
    let adjustedDamage = damageEvent.applyStanceAdjustments(victim);
    adjustedDamage = damageEvent.applyArmorAdjustment(victim);

    if (ability.melee && !is_dummy) {
      // check for armor spikes
      const spikes = BattleCalc.getPassiveAbility(victim, 'armor_spikes');
      if (spikes) {
        const spikesDamage = adjustedDamage * spikes.potency;
        if (spikesDamage > 0) {
          const damageEvent = new DamageEvent(
            battleState,
            victim,
            spikesDamage,
            this
          );
          damageEvent.execute(actor, false);
        }
      }
    }

    if (isNaN(damageEvent.damage)) {
      return result;
    }

    damageEvent.execute(victim, true, is_dummy);

    if (victim.hp > 0 && (ability.weapon || ability.bow) && !is_dummy) {
      if (damageEvent.damage > 0) {
        checkForPoison();
      }

      checkForWeaponProc();
    }

    return result;

    function checkForPoison() {
      var poisoner = BattleCalc.getCondition(actor, 'poisoner');
      if (poisoner) {
        --poisoner.charges;
        if (poisoner.charges <= 0) {
          battleState.expireCondition(poisoner.uid);
        }

        addPoisonedCondition(poisoner.potency);
      }
    }

    function checkForWeaponProc() {
      var prefix;
      var suffix;

      if (ability.weapon) {
        var weapon = actor.equipment.weapon;
        if (!weapon) {
          return;
        }
        prefix = weapon.prefix;
        suffix = weapon.suffix;
      } else if (ability.bow) {
        var off_hand = actor.equipment.off_hand;
        if (!off_hand || off_hand.type !== 'bow') {
          return;
        }
        prefix = off_hand.prefix;
        suffix = off_hand.suffix;
      }

      if (prefix === 'vampiric' && damageEvent.damage > 0) {
        const healEvent = new HealEvent(
          battleState,
          actor,
          Math.round(damageEvent.damage * 0.15)
        );
        healEvent.execute(actor);
        ability.eventEmitter.emit('result', healEvent);
      } else if (prefix === 'venomous' && damageEvent.damage > 0) {
        addPoisonedCondition(5 + actor.level * 0.3);
      } else if (prefix === 'weeping' && damageEvent.damage > 0) {
        // calculate bleed condition potency using a dummy damage event,
        // so we can apply stance adjustments, hero Affinities, etc.
        var bleedDamageDummy = new DamageEvent(
          battleState,
          actor,
          5 + actor.level * 0.3,
          ability
        );
        bleedDamageDummy.applyStanceAdjustments(victim);
        const bleed_potency = bleedDamageDummy.damage;

        // if the victim already has a bleeding condition with same instigator, add to its potency
        var bleeding = BattleCalc.getCondition(victim, 'bleeding', actor.uid);
        if (bleeding) {
          bleeding.potency += bleed_potency;
          battleState.updateCondition(victim.uid, bleeding.uid);
        } else {
          battleState.onUnitCondition(
            new BleedingCondition(actor, victim, battleState, bleed_potency)
          );
        }
      } else if (prefix === 'gladiator' && Math.random() < 0.2) {
        battleState.onUnitCondition(
          new StunnedCondition(
            actor,
            victim,
            battleState,
            2000 + 50 * actor.level
          )
        );
      }

      // weapon procs
      if (!actor.poppet) {
        if (suffix === 'thunder' && Math.random() < 0.2) {
          ability.eventEmitter.emit('proc', {
            procHandle: 'thunder',
            actor,
            victim,
          });
        } else if (suffix === 'fire' && Math.random() < 0.2) {
          ability.eventEmitter.emit('proc', {
            procHandle: 'fire',
            actor,
            victim,
          });
        } else if (suffix === 'ice' && Math.random() < 0.2) {
          ability.eventEmitter.emit('proc', {
            procHandle: 'ice',
            actor,
            victim,
          });
        } else if (suffix === 'terror' && Math.random() < 0.07) {
          battleState.onUnitCondition(
            new ScaredCondition(
              actor,
              victim,
              battleState,
              2000 + 50 * actor.level
            )
          );
        }
      }
    }

    function addPoisonedCondition(potency) {
      // calculate bleed condition potency using a dummy damage event,
      // so we can apply stance adjustments, hero Affinities, etc.
      const poisonDamageDummy = new DamageEvent(
        battleState,
        actor,
        potency,
        _cause
      );
      poisonDamageDummy.applyStanceAdjustments(victim);
      const poison_potency = poisonDamageDummy.damage;

      // if the victim already has a poisoned condition with same instigator, add to its potency
      var poisoned = BattleCalc.getCondition(victim, 'poisoned', actor.uid);
      if (poisoned) {
        poisoned.potency += poison_potency;
        battleState.updateCondition(victim.uid, poisoned.uid);
      } else {
        battleState.onUnitCondition(
          new PoisonedCondition(actor, victim, battleState, poison_potency)
        );
      }
    }
  };
};
module.exports = StandardStrike;
